import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  ApolloLink,
  from,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';

const cache = new InMemoryCache();

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

const mainHttpLink = createHttpLink({
  uri: process.env.REACT_APP_BASE_API + '/b2c',
});

const shopHttpLink = createHttpLink({
  uri: process.env.REACT_APP_SHOP_API,
});

const httpLinks = ApolloLink.split(
  (operation) => operation.getContext().clientName === 'shop-api',
  shopHttpLink, // Send to this if clientName is "shop-api"
  mainHttpLink // Otherwise, send to this
);

const errorLink = onError(({ operation, forward }) => {
  forward?.(operation);
});

function getHeaders(isShopApi) {
  let customHeaders = {};

  if (isShopApi) {
    customHeaders['hq-storefront'] = window.location.href
      .split('/')[3]
      .split('?')[0];
    customHeaders['hq-marketplace'] = window.location.href
      .split('/')[2]
      .split('.')[0];
  } else {
    customHeaders['Scheduler-HQ-Storefront'] = window.location.href
      .split('/')[3]
      .split('?')[0];
    customHeaders['Scheduler-HQ-Marketplace'] = window.location.href
      .split('/')[2]
      .split('.')[0];
  }

  const sessionToken = localStorage.getItem('buyerToken');
  if (sessionToken) {
    customHeaders['Scheduler-HQ-Session'] = sessionToken;
  }

  return customHeaders;
}

const authLink = new ApolloLink((operation, forward) => {
  const isShopApi = operation.getContext().clientName === 'shop-api';

  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      ...getHeaders(isShopApi),
    },
  }));

  return forward(operation);
});

export const clientConfig = new ApolloClient({
  cache: cache,
  link: from([authLink, errorLink, httpLinks]),
  defaultOptions,
});
